var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.113,
    height: 31.047,
    viewBox: "0 0 30.113 31.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "CrossIcon",
    d: "M4.685,0,0,5.033l11.91,9.583L.621,25.877l3.822,4.533L14.451,19.689l11.4,10.847,3.732-6.222-9.254-9.288,9.19-11.441L26.77.362l-11.7,10.664Z",
    transform: "matrix(1, -0.017, 0.017, 1, 0, 0.516)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.10265b75e44ef8fb3302c94c0edbfcd7.svg";
export { ForwardRef as ReactComponent };